import { Button, FieldWrapper, FormField, Icon } from '@dixa/lib-shared-habla';
import { Path, useFormContext, useWatch } from 'react-hook-form';

import { OAuthStrategySchemaField } from 'apis/partnerIntegrations';
import { HookFormText } from 'components/hookForm';

import { OAuthFormData, OAuthFormDataField } from '../../../../oAuth.types';

type SchemaFieldProps = {
  schema: OAuthStrategySchemaField;
  disabled: boolean;
  hasFormValues: boolean;
};

/** A form field based on the strategy schema. */
export const SchemaField = ({
  schema,
  disabled,
  hasFormValues,
}: SchemaFieldProps): JSX.Element => {
  const { control, setValue } = useFormContext<OAuthFormData>();
  const watchForm = useWatch({ control });

  const isEditing = (watchForm[schema.key] as OAuthFormDataField)?.isEditing;

  if (hasFormValues && schema.secret && !isEditing) {
    return (
      <FormField key={schema.key}>
        <FieldWrapper disabled={disabled} label={schema.label}>
          <Button
            variant="secondary"
            slotStart={<Icon name="pen" />}
            onClick={() => setValue(`${schema.key}.isEditing`, true)}
          >
            Click to set a new secret value
          </Button>
        </FieldWrapper>
      </FormField>
    );
  }

  return (
    <FormField key={schema.key}>
      {schema.type === 'string' ? (
        <HookFormText
          disabled={disabled}
          label={schema.label}
          name={`${schema.key}.value` as Path<OAuthFormData>}
          control={control}
          componentProps={{
            placeholder: `Insert ${schema.label}`,
            ...(schema.secret &&
              isEditing && {
                prefix: {
                  type: 'button',
                  button: {
                    icon: 'arrow-left',
                    onClick: () => setValue(`${schema.key}.isEditing`, false),
                  },
                },
              }),
          }}
          rules={{
            required: {
              value: schema.required,
              message: 'This field is required',
            },
          }}
        />
      ) : (
        <>This input type is currently not supported: {schema.type}.</>
      )}
    </FormField>
  );
};
